export enum PageIds {
  HOME = 'HOME',
  ECO_SCORE = 'ECO_SCORE',
  THREE_D = 'THREE_D',
  PROPELLERS = 'PROPELLERS',
  RUDDER = 'RUDDER',
  THRUSTER = 'THRUSTER',
  GEARBOX = 'GEARBOX',
  CHILLER = 'CHILLER',
  ENGINES = 'ENGINES',
  BATTERY = 'BATTERY',
  SAFETY_PLAN = 'SAFETY_PLAN',
  YACHT_PAGE = 'YACHT_PAGE',
  WATERMAKERS = 'WATERMAKERS',
  GENERATORS = 'GENERATORS',
  TANKS = 'TANKS',
  STABILIZERS = 'STABILIZERS',
  TIMES = 'TIMES',
  SPEED_DISTANCE = 'SPEED_DISTANCE',
  DEPTH = 'DEPTH',
  BAROMETRIC_PRESSURE = 'BAROMETRIC_PRESSURE',
  WIND = 'WIND',
  MAP = 'MAP',
  VIDEO = 'VIDEO',
  DETAILS = 'DETAILS',
  INFO = 'INFO',
  WEATHER = 'WEATHER',
  DISTANCE = 'DISTANCE',
  MEKKAH = 'MEKKAH',
  PINCODE = 'PINCODE',
  TEMPERATURES = 'TEMPERATURES',
  CALENDAR = 'CALENDAR',
  CREW = 'CREW',
  TRIP = 'TRIP',
  SAT_ANTENNAS = 'SAT_ANTENNAS',
  GALLERY = 'GALLERY',
  INFO_CHANNEL = 'INFO_CHANNEL',
  PDF = 'PDF',
  PRESENTATIONS = 'PRESENTATIONS',
}

const ids = Object.values(PageIds).map(id => `${id}`.toLowerCase())

export const pageIdentifiers = ids.concat(['admin/settings', 'admin/tv_mode/3d'])
